import { DiscountType } from "../../../__generated__/globalTypes";
import { AmountToPay } from "./getAmountToPay";

export const getShortestLivingDiscount = (fees: AmountToPay["fees"]) => {
  return fees.length > 0
    ? fees.reduce((acc, fee) => {
        if (
          fee.maxInvoicesSpread === acc.maxInvoicesSpread &&
          acc.discountType === DiscountType.MultiPet
        ) {
          return fee;
        }

        return fee.maxInvoicesSpread < acc.maxInvoicesSpread ? fee : acc;
      })
    : null;
};
